<template>
  <div class="row mx-0">
    <div class="col-12 px-0">
      <div class="card border-0 rounded-0">
        <div class="card-body mini-nav bg-primary pt-2 pb-3 px-0">
          <nav class="navbar navbar-expand-md navbar navbar-dark bg-primary py-2 px-3">
            <button
                class="navbar-toggler btn btn-sm px-3 font-size-16 header-item waves-effect h-auto text-primary"
                type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup"
                aria-controls="navbarNavAltMarkup" aria-expanded="false"
                aria-label="Toggle navigation">
              <span class="mdi mdi-menu"></span>
            </button>
            <div class="collapse navbar-collapse justify-content-between"
                 id="navbarNavAltMarkup">
              <div class="navbar-nav">
                <a :class="activeClass" @click="gotTo('parking_dashboard')" href="javascript:void(0)">Quick Stats</a>
                <a :class="activeClass2" @click="gotTo('parking-fleet')" href="javascript:void(0)">Seasonal Parking</a>
                <a :class="activeClass3" @click="gotTo('daily_parking')" href="javascript:void(0)">Daily Parking</a>
                <a :class="activeClass4" @click="gotTo('monthly_parking')" href="javascript:void(0)">Monthly Parking</a>
                <a :class="activeClass5" @click="gotTo('weekly_parking')" href="javascript:void(0)">Weekly Parking</a>
                <a :class="activeClass6" @click="gotTo('bus_park')" href="javascript:void(0)">Bus/matatu Parks</a>
                <a :class="activeClass7" @click="gotTo('vehicles_register')" href="javascript:void(0)">Vehicles Register</a>
                <a :class="activeClass8" @click="gotTo('clamped_vehicles')" href="javascript:void(0)">Clamped Vehicles</a>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>

    <!-- Scrolling Stats Banner -->
    <div class="col-12 px-0">
      <div class="stats-banner">
        <div class="stats-scroll" :style="{ transform: `translateX(${scrollPosition}px)` }">
          <div class="stats-item" v-for="(stat, index) in duplicatedStats" :key="`stat-${index}`">
            <span class="stats-icon">{{ getStatIcon(stat.label) }}</span>
            <span class="stats-label">{{ stat.label }}:</span>
            <span class="stats-value">{{ stat.value }}</span>
            <span class="stats-divider" v-if="index < duplicatedStats.length - 1">|</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {execute, parking} from "@/api";

export default {
  name: "ToolBar",
  data(){
    return{
      subCountyName:'',
      currentPage:'',
      scrollPosition: 0,
      scrollSpeed: 1,
      scrollInterval: null,
      // Stats for the banner - will be updated from API
      marqueeStats: [
        { label: "TODAY'S HIGHLIGHTS", value: "0%" },
        { label: "LOGGED VEHICLES", value: "0" },
        { label: "CAR QUERIES", value: "0" },
        { label: "COMPLIANT", value: "0" },
        { label: "NON-COMPLIANT", value: "0" },
        { label: "DUE CLAMPING", value: "0" },
        { label: "CLAMPED", value: "0" },
        { label: "BUS/MATATU PARK REVENUE", value: "KES 0" },
        { label: "CLAMPING REVENUE", value: "KES 0" },
        { label: "INACTIVE AG", value: "0" }
      ]
    }
  },

  computed: {
    duplicatedStats() {
      // Duplicate the array to create seamless scrolling
      return [...this.marqueeStats, ...this.marqueeStats];
    },
    activeClass() {
      return {
        'nav-item': true,
        'nav-link': true,
        'active': this.currentPage === 'parking_dashboard'
      }
    },
    activeClass2() {
      return {
        'nav-item': true,
        'nav-link': true,
        'active': this.currentPage === 'parking-fleet'
      }
    },
    activeClass3() {
      return {
        'nav-item': true,
        'nav-link': true,
        'active': this.currentPage === 'daily_parking'
      }
    },
    activeClass4() {
      return {
        'nav-item': true,
        'nav-link': true,
        'active': this.currentPage === 'monthly_parking'
      }
    },
    activeClass5() {
      return {
        'nav-item': true,
        'nav-link': true,
        'active': this.currentPage === 'weekly_parking'
      }
    },
    activeClass6() {
      return {
        'nav-item': true,
        'nav-link': true,
        'active': this.currentPage === 'bus_park'
      }
    },
    activeClass7() {
      return {
        'nav-item': true,
        'nav-link': true,
        'active': this.currentPage === 'vehicles_register'
      }
    },
    activeClass8() {
      return {
        'nav-item': true,
        'nav-link': true,
        'active': this.currentPage === 'clamped_vehicles'
      }
    }
  },

  mounted() {
    this.currentPage = sessionStorage.getItem("currentPage")
    this.getMarqueeStats()
    this.startScrolling()
    this.updateStatsData()
  },

  beforeUnmount() {
    this.stopScrolling()
  },

  methods:{
    gotTo(route){
      sessionStorage.setItem("currentPage",route)
      this.$router.push(route);
    },

    getMarqueeStats(){
      const data = new FormData();
      data.append("function", "getMarqueeStats");
      execute(data,parking)
          .then((res) =>{
            if (res.data.success) {
              this.marqueeStats = res.data.data.marqueeStats
            }else{
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    // Get icon based on stat label
    getStatIcon(label) {
      const iconMap = {
        "TODAY'S HIGHLIGHTS": "📊",
        "LOGGED VEHICLES": "🚗",
        "CAR QUERIES": "🔍",
        "COMPLIANT": "✅",
        "NON-COMPLIANT": "❌",
        "DUE CLAMPING": "⚠️",
        "CLAMPED": "🔒",
        "BUS/MATATU PARK REVENUE": "🚌",
        "CLAMPING REVENUE": "💰",
        "INACTIVE AG": "👤"
      };
      return iconMap[label] || "📊";
    },

    // Scrolling animation methods
    startScrolling() {
      this.scrollInterval = setInterval(() => {
        this.scrollPosition -= this.scrollSpeed;

        // Calculate total width of all stats
        const statsWidth = this.getContentWidth();

        // Reset position when first set has completely scrolled out
        if (Math.abs(this.scrollPosition) >= statsWidth) {
          this.scrollPosition = 0;
        }
      }, 16); // 60fps
    },

    stopScrolling() {
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
      }
    },

    getContentWidth() {
      // More accurate width calculation based on actual content
      // Approximate width per stat item (adjust based on your actual content)
      const avgWidthPerItem = 250; // pixels
      return this.marqueeStats.length * avgWidthPerItem;
    },

    updateStatsData() {
      // Update stats periodically
      setInterval(() => {

      }, 30000); // Update every 30 seconds
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num)
    }
  }
}

</script>

<style scoped>
/* Stats Banner Styles */
.stats-banner {
  width: 100%;
  height: 50px;
  background: linear-gradient(90deg, #dc2626, #ea580c, #dc2626);
  color: white;
  overflow: hidden;
  position: relative;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin: 0;
  border: none;
  padding: 0;
}

/* Remove all margins and padding from row and columns */
.row {
  margin: 0 !important;
}

.col-12 {
  padding: 0 !important;
}

.card {
  margin-bottom: 0 !important;
  border: none !important;
  border-radius: 0 !important;
}

.card-body {
  margin-bottom: 0 !important;
  padding-bottom: 0.75rem !important;
}

/* Remove border radius from navbar */
.navbar {
  border-radius: 0 !important;
}

/* Ensure the navbar background extends edge to edge */
.mini-nav {
  border-radius: 0 !important;
}

.stats-scroll {
  display: flex;
  align-items: center;
  height: 100%;
  white-space: nowrap;
  transition: transform 0.016s linear;
  will-change: transform; /* Optimize for animations */
}

.stats-item {
  display: inline-flex;
  align-items: center;
  margin-right: 3rem;
  font-size: 14px;
  font-weight: 600;
  min-width: max-content;
  flex-shrink: 0; /* Prevent items from shrinking */
}

.stats-icon {
  margin-right: 8px;
  font-size: 16px;
}

.stats-label {
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-right: 8px;
  font-weight: 600;
}

.stats-value {
  font-weight: 700;
  color: #fef3c7;
  margin-right: 16px;
}

.stats-divider {
  color: #fbbf24;
  margin-right: 16px;
  font-weight: bold;
}

/* Hover effect for stats banner */
.stats-banner:hover .stats-scroll {
  animation-play-state: paused;
}

/* Navigation link styles */
.nav-link {
  transition: all 0.3s ease;
  border-radius: 4px;
  margin: 0 2px;
}

.nav-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.nav-link.active {
  background-color: rgba(255, 255, 255, 0.2);
  font-weight: 600;
}

/* Responsive */
@media (max-width: 768px) {
  .stats-item {
    font-size: 12px;
    margin-right: 2rem;
  }

  .stats-banner {
    height: 45px;
  }

  .stats-icon {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .stats-item {
    font-size: 11px;
    margin-right: 1.5rem;
  }

  .stats-banner {
    height: 40px;
  }

  .stats-icon {
    font-size: 12px;
  }
}

/* Smooth scrolling animation */
@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
</style>